import axios from "axios";

const instance = axios.create({
  // baseURL: "/api",
  baseURL: 'https://open-api.unisat.io/v1/indexer',
  timeout: 60000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=utf-8",
    "Authorization": "Bearer c1f9541f9037b9b82ff993d3b465b543d1b750eafbef0284ab04e5fad10c69fc"
  },
});

instance.interceptors.request.use(
  (config) => {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    const { status, data } = response
    if(status === 200 && data?.code === 0) {
      return data.data
    } else {
      return null
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance